
// Firebase Produzione
export const environment = {
  production: true,
   firebaseConfig: {
   apiKey: "AIzaSyApvtTEQuFbb0CnyucB7bxVN3uA4C9Jr90",
  authDomain: "istatennisgame.firebaseapp.com",
  databaseURL: "https://istatennisgame.firebaseio.com",
  projectId: "istatennisgame",
  storageBucket: "istatennisgame.appspot.com",
  messagingSenderId: "142658964979",
  appId: "1:142658964979:web:a690454bd59ffc0bc35686",
  measurementId: "G-2E6MPGW9M9",
  domain: "istatennisgame.web.app"
  }
};

// Firebase Collaudo
// export const environment = {
//   production: false,
//    firebaseConfig: {
//    apiKey: "AIzaSyCDuTXJvF9Vxh9NsTBUymhLtzVRoLdrFg0",
//   authDomain: "istatennisgame-coll.firebaseapp.com",
//   databaseURL: "https://istatennisgame-coll.firebaseio.com",
//   projectId: "istatennisgame-coll",
//   storageBucket: "istatennisgame-coll.appspot.com",
//   messagingSenderId: "393474157901",
//   appId: "1:393474157901:web:f5750c525effa77e525b04",
//   measurementId: "G-HL0Q65G6RG"
//   },
//   domain: "localhost"
// };

